#
# Paginator implements the hassle-free AJAX-based routing
# To make things work a controller should be able to respond with JS
#
class @Paginator

  @setup: (selector) ->

    $(document).on "change", selector, ->

      select                  = $(this)
      perPage                 = select.val()
      paginatedTableContainer = select.closest(".paginated-table-container")
      url                     = paginatedTableContainer.data("url") || ""

      if url.indexOf("?") >= 0
        url += "&"
      else
        url += "?"

      params = $.url().param()

      params.per_page = perPage
      params.page = 1

      url += $.param(params)

      $.getScript(url)

      return false
